import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    flex: 1,
    position: 'relative',
    display: 'flex'
  }
});

const Content = ({ children, ...rest }) => {

  const { classes } = rest;

  return (
    <div className={ classNames('Container-Content', classes.root) } {...rest}>
      { children }
    </div>
  )
}

Content.propTypes = {
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(Content);
